import styled, { keyframes } from 'styled-components';

interface IFullHeightContainer {
  $arrowActive?: boolean;
}

export const FullHeightContainer = styled.div<IFullHeightContainer>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: env(safe-area-inset-bottom);
  min-height: ${(props: IFullHeightContainer) =>
    props.$arrowActive ? 'calc(100vh - 80px)' : '0'};
`;

interface IArrowActive {
  $arrowActive?: boolean;
  $boxPaddingTop?: number;
  $boxPaddingTopMobile?: number;
}

export const CenterContainer = styled.div<IArrowActive>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-grow: ${(props: IArrowActive) => (props.$arrowActive ? '1' : '0')};

  & > * {
    padding-top: ${(props: IArrowActive) =>
      props.$arrowActive ? '0' : `${props.$boxPaddingTop}px`};
  }
  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    & > * {
      padding-top: ${(props: IArrowActive) =>
        props.$arrowActive ? '0' : `${props.$boxPaddingTopMobile}px`};
    }
  }
`;

const rotate = keyframes`
0% {
    transform: scale(1, 1) translateY(0px);
}
10% {
    transform: scale(1.1, 0.9) translateY(0px);
}
30% {
    transform: scale(0.9, 1.1) translateY(-30px);
}
50% {
    transform: scale(1.05, 0.95) translateY(0px);
}
57% {
    transform: scale(1, 1) translateY(-7px);
}
64% {
    transform: scale(1, 1) translateY(0px);
}
100% {
    transform: scale(1, 1) translateY(0px);
}
`;

export const ArrowBox = styled.div<IArrowActive>`
  display: ${(props: IArrowActive) => (props.$arrowActive ? 'flex' : 'none')};
  justify-content: center;
  align-items: flex-end;
`;

export const ArrowLink = styled.div`
  padding: 40px 10px 10px;
  cursor: pointer;
`;

export const Arrow = styled.img`
  animation: ${rotate} 4s cubic-bezier(0.28, 0.84, 0.42, 1) infinite;
`;
